module.exports = __webpack_public_path__ + "media/images/DDlogo-ab60a15b2447c1a72a0ee5abbb8b3183.png";